import { useState, useEffect } from 'react';

export const useIsMobile = () => {
  // Start with undefined to prevent hydration mismatch
  const [isMobile, setIsMobile] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    const checkMobile = () => {
      if (typeof window !== 'undefined') {
        const userAgent = navigator.userAgent;
        setIsMobile(/Mobile|Android|iPhone|iPad|iPod/i.test(userAgent));
      }
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Return false during SSR, actual value after hydration
  return isMobile ?? false;
};

// For cases where we need to check mobile outside of React components
export const isMobileDevice = () => {
  if (typeof window === 'undefined') return false;
  return /Mobile|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}; 